import { SystemFonts } from "../../../../src/components/SystemFonts";
import * as React from 'react';
export default {
  SystemFonts,
  React
};